import script from "./amazon-attribution-and-sales-reporting.vue?vue&type=script&setup=true&lang=js"
export * from "./amazon-attribution-and-sales-reporting.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__